import { makeStyles } from '@material-ui/core/styles';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  formMessage: {
    fontSize: '14px',
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '16px',
    marginBottom: '8px',
  },
  modalBody: {
    marginBottom: '30px',
  },
});

export default useStyles;
